import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { performanceStages } from "../data/engine-build-stages";
import Carousel from "./Carousel";

const EngineStagesSection = () => {
  // Define images for the carousel
  const carouselImages = [
    `${process.env.PUBLIC_URL}/4l/after_compressed/1.jpg`,
    `${process.env.PUBLIC_URL}/4l/after_compressed/4.jpg`,
    `${process.env.PUBLIC_URL}/4l/after_compressed/19.jpg`,
    `${process.env.PUBLIC_URL}/4l/after_compressed/13.jpg`,
    `${process.env.PUBLIC_URL}/4l/after_compressed/17.jpg`,
    `${process.env.PUBLIC_URL}/4l/after_compressed/18.jpg`,
    `${process.env.PUBLIC_URL}/4l/after_compressed/5.jpg`,

  ];

  return (
    <div className={`article-page dark`}>
        <div className="content-container">
    <section className="bg-dark text-white py-0">
      <div className="text-center max-w-4xl  mb-12">
        <h2 className="text-4xl font-bold text-left leading-relaxed">{performanceStages.title}</h2>
        <p className="text-lg mt-4 text-gray-300 text-left">{performanceStages.subtitle}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto">
        {performanceStages.stages.map((stage) => (
          <div
            key={stage.id}
            className="bg-gray-900 p-6 rounded-xl shadow-lg flex flex-col h-full justify-between"
          >
            <div>
              <span className="text-sm font-semibold text-gray-400">{stage.level}</span>
              <h3 className="text-2xl font-bold text-white text-left mt-2">{stage.name}</h3>
              <p className="text-sm italic text-gray-400 mt-1">{stage.targetAudience}</p>
              <p className="text-base text-gray-200 mt-4">{stage.description}</p>

              {stage.features.length > 0 && (
                <ul className="mt-4 space-y-2 text-left">
                  {stage.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-2 text-green-400 text-sm">
                      <FontAwesomeIcon icon={faCheck} className="mt-1" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {/* <div className="mt-6">
              <a
                href={stage.link}
                className="inline-block text-sm text-white font-medium underline hover:text-green-400 transition"
              >
                Mehr erfahren →
              </a>
            </div> */}
          </div>
        ))}
      </div>
      
      {/* Add Carousel */}
      <Carousel images={carouselImages} />
    </section>
    </div>
    </div>
  );
};

export default EngineStagesSection;
